module.exports = __webpack_public_path__ + "components/flag/static/square/gb-b357d877245a043a7daa478283dbfd4a.svg";